// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
const React = require('react')

function PageSlicer(WrappedComponent) {
  class PageSlicer extends React.PureComponent {
    slicedProps() {
      const { pageCount, pageStart } = this.props
      if (!pageCount && !pageStart) {
        // If there's no slicing to be done, just pass props through
        return this.props
      }
      return Object.assign({}, this.props, { items: this.slicedItems() })
    }

    slicedItems() {
      const { items, pageCount, pageSize, pageStart } = this.props
      // Treat pageStart: 0 and pageStart: 1 as the first page
      const itemStart = pageStart < 2 ? 0 : pageSize * (pageStart - 1)
      // Treat pageCount: 0 as "the rest of the pages"
      const itemEnd = pageCount ? itemStart + (pageSize * pageCount) : undefined
      return items.slice(itemStart, itemEnd)
    }

    render() {
      return React.createElement(WrappedComponent, this.slicedProps())
    }
  }

  const { displayName, name } = WrappedComponent
  PageSlicer.displayName = `PageSlicer(${displayName || name || 'Component'})`

  PageSlicer.propTypes = {
    items: PropTypes.oneOfType([
      PropTypes.instanceOf(Array),
      PropTypes.instanceOf(Immutable.Iterable)
    ]).isRequired,
    pageCount: PropTypes.number,
    pageSize: PropTypes.number.isRequired,
    pageStart: PropTypes.number
  }

  return PageSlicer
}

module.exports = PageSlicer
